// Utility function to trigger analytics events
export function trackEvent(eventName: string, eventData?: Record<string, any>) {
  // Only run in browser environment
  if (typeof window === "undefined") {
    return
  }

  // Push to dataLayer if GTM is available
  if (window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...eventData,
    })
  }

  // Log events during development
  if (process.env.NODE_ENV === "development") {
    console.log(`Analytics Event: ${eventName}`, eventData)
  }

  // Dispatch a custom event that can be listened to by other scripts
  const event = new CustomEvent("analytics", {
    detail: {
      name: eventName,
      data: eventData,
    },
  })
  window.dispatchEvent(event)
}

// Add TypeScript interface for window.dataLayer
declare global {
  interface Window {
    dataLayer?: any[]
  }
}

